
import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Label } from "@/components/ui/label";
import { X } from "lucide-react";

interface VenueListProps {
  venues: string[];
  onRemoveVenue: (venue: string) => void;
  label?: string;
}

export const VenueList = ({ venues, onRemoveVenue, label = "Selected Suburbs" }: VenueListProps) => {
  if (venues.length === 0) return null;

  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      <div className="flex flex-wrap gap-2">
        {venues.map((venue, index) => (
          <Badge
            key={index}
            variant="secondary"
            className="flex items-center gap-1 px-3 py-1"
          >
            {venue}
            {onRemoveVenue && (
              <button 
                type="button" 
                onClick={() => onRemoveVenue(venue)}
                className="ml-1 text-muted-foreground hover:text-foreground focus:outline-none"
                aria-label={`Remove ${venue}`}
              >
                <X size={14} />
              </button>
            )}
          </Badge>
        ))}
      </div>
    </div>
  );
};
